@if ((hasPlantModel$ | async) === false || canOpenBodePlot === false) {
  <div class="alert alert-warning mb-3 shadow-sm">
    <i class="bi-exclamation-triangle-fill me-1"></i>
    No plant model is found on the device.
  </div>
}

@if ((hasPlantModel$ | async) && (hasSavedPlantValues$ | async) === false) {
  <div class="alert alert-warning mb-3 shadow-sm">
    <i class="bi-exclamation-triangle-fill me-1"></i>
    Chirp inputs do not reflect the identified plant model.
  </div>
}

@if (showDescription) {
  <p class="text-body-secondary">
    System identification procedure sends a torque excitation signal and records a velocity response of the motor-load
    system. Then it identifies physical properties of the object to build a model of the plant. The model is then used
    during the auto-tuning procedures.
  </p>
}

@if (advancedToggleButtonVisible) {
  <div class="d-flex justify-content-end my-3">
    <app-toggle-visibility-button
      (toggleFilter)="onToggleFilterButton($event)"
      label="advanced controls"
    ></app-toggle-visibility-button>
  </div>
}

<div class="row">
  <app-plant-model [device]="device" [componentMode]="componentMode" [filterActive]="filterActive"></app-plant-model>
</div>

@if (torqueOffsetFormVisible) {
  <div class="row my-2">
    <app-parameter-form
      [parameters$]="torqueOffset$"
      [showUnit]="true"
      [submitDisabled]="false"
      [showApplyButton]="true"
      (apply)="onTorqueOffsetSubmit($event)"
      (formSubmit)="onTorqueOffsetSubmit($event.value)"
    >
    </app-parameter-form>
  </div>
}

<ng-container *appIsPdoControlMode>
  <hr />

  <div class="col my-2">
    <div class="row mb-2">
      <div class="col-lg-5">
        <label for="limitedRangeSysIdEnabled" class="col-form-label">
          Limited Range Sys ID <app-beta-badge></app-beta-badge>
        </label>
      </div>

      <div class="col-lg">
        <div class="input-group">
          <select
            id="limitedRangeSysIdEnabled"
            class="form-control form-select"
            [(ngModel)]="limitedRangeSysIdEnabled"
            (change)="onLimitedRangeSysIdChange()"
          >
            <option [ngValue]="true">Enabled</option>
            <option [ngValue]="false">Disabled</option>
          </select>
          <div class="d-inline-flex">
            <button
              class="btn btn-outline-link rounded-0 border-top-0 border-end-0 border-bottom-0 btn-parameter-help text-body-secondary"
              type="button"
              (click)="openLimitedRangeSysIdModal()"
              tabindex="-1"
              title="Open documentation"
            >
              <i class="bi-info-circle"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    @if (limitedRangeSysIdEnabled) {
      <div class="row mb-2">
        <app-parameter-form #lrsiForm [parameters$]="lrsiParameters$" [showUnit]="true" [showApplyButton]="false">
        </app-parameter-form>
      </div>
    }
    <app-parameter-form
      [parameters$]="parameters$"
      [showApplyButton]="false"
      [showSubmit]="(operationEnabled$ | async) === false && (quickStopActive$ | async) === false"
      [submitDisabled]="starting || (isMotionPrevented$ | async)"
      [submitText]="submitText"
      [submitTooltip]="motionPreventedMessage$ | async"
      (formSubmit)="onFormSubmit($event)"
    >
    </app-parameter-form>
  </div>

  @if (operationEnabled$ | async) {
    <div class="row my-2">
      <div class="col">
        <button type="button" class="btn btn-danger fw-bold w-100" (click)="onStop()">STOP</button>
      </div>
    </div>
  }

  @if (quickStopActive$ | async) {
    <div class="row my-2">
      <div class="col">
        <button type="button" class="btn btn-secondary w-100" (click)="onDisableMotionController()">
          DISABLE CONTROLLER
        </button>
      </div>
    </div>
  }

  <div class="col">
    <button
      (click)="openBodePlotModal()"
      [disabled]="canOpenBodePlot === false"
      type="button"
      class="btn btn-outline-primary w-100 my-2"
    >
      SHOW BODE PLOT
    </button>
  </div>
</ng-container>
